import { useTranslation } from 'next-i18next'

import Button from '~/components/Buttons/Button'

import ROUTES from '~/shared/constants/routes.const'

import GamificationUserSection from './GamificationUserSection'
import DashboardAvatarImage from './DashboardAvatarImage'

export default function DashboardGamificationCard(): React.ReactElement {
  const { t } = useTranslation('dashboard')
  return (
    <div className="flex flex-col justify-start gap-2 w-full">
      <DashboardAvatarImage />
      <GamificationUserSection />
      <Button
        className="mx-3 lg:mx-4 bg-purple h-11 shadow-purple-drop-glow !rounded-full font-bold text-xs"
        href={ROUTES.STATISTICS}
      >
        {t('dashboard:viewStats')}
      </Button>
    </div>
  )
}
